import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheetOverviewComponent } from 'src/app/shared/components/bottom-sheet-overview/bottom-sheet-overview.component';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { Presupuesto } from 'src/app/shared/models/presupuesto';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { DateAdapter } from '@angular/material/core';
import { Constanst } from 'src/app/core/constants/constans.component';
import { BudgetDetails } from 'src/app/shared/models/detalle-presupuesto';
import { BudgetItem } from 'src/app/shared/models/partida-presupuesto';
import { CachePartidasService } from 'src/app/core/services/cache-partidas-service';
import { MatSort } from '@angular/material/sort';
import { BudgetSignatures } from 'src/app/shared/models/firmas-presupuesto';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
  selector: 'app-presupuestos',
  templateUrl: './presupuestos.component.html',
  styleUrls: ['./presupuestos.component.css'],
  providers: [DatePipe, DecimalPipe]
})
export class PresupuestosComponent implements OnInit {

  displayedColumns: string[] = ['creationDate', 'typeBudget', 'companyBudget', 'titleWork', 'location', 'contractor', 'lineItemNumber', 'grandTotal', 'actions'];
  dataSourceFilters = new MatTableDataSource<Presupuesto>;
  messageError: string;

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  @ViewChild(MatSort) sort: MatSort;

  listPresupuestos: Presupuesto[] = [];
  cantidadPartidas: number = 0;

  constructor(
    private bottomSheet: MatBottomSheet,
    private router: Router,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private cachePartidasService: CachePartidasService,
    private dateAdapter: DateAdapter<Date>,
    private datePipe: DatePipe,
    private localStorageService: LocalStorageService) { this.dateAdapter.setLocale(Constanst.LOCALE_VE); }

  openBottomSheet(): void {
    this.bottomSheet.open(BottomSheetOverviewComponent);
  }

  ngAfterViewInit() {
    this.dataSourceFilters.sort = this.sort;
  }

  ngOnInit() {
    this.cachePartidasService.clear();
    this.getAllBudget();
  }

  getAllBudget() {
    this.route = '/getAllBudgetByUser';
    this.method = 'GET';
    let data = {
      idUser: this.localStorageService.getItem(Constanst.STORAGE_DATA_USER)
    };
    this.listPresupuestos = [];

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {

          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            for (let i = 0; i < response.data.length; i++) {
              let listFirmasPresupuesto: BudgetSignatures[] = [];
              let totalPresupuesto: number = 0, totalIvaPresupuesto: number = 0, tipoIva: number = 0, totalOtrosImpPresupuesto: number = 0;

              if (response.data[i].totalBudget > 0) {
                totalPresupuesto = response.data[i].totalBudget;
                tipoIva = response.data[i].applyIva;
                totalIvaPresupuesto = (totalPresupuesto * ((tipoIva == 1 ? response.data[i].iva : 0) / 100));
                totalOtrosImpPresupuesto = (totalPresupuesto * ((tipoIva == 1 ? response.data[i].otherTax : 0) / 100));
              } else {
                totalPresupuesto = 0;
                totalIvaPresupuesto = 0;
                totalOtrosImpPresupuesto = 0;
              }

              if (response.data[i].firstSigneName != null && response.data[i].firstSigneName.trim() != '' &&
                response.data[i].firstSigneDescription != null && response.data[i].firstSigneDescription.trim() != '' &&
                response.data[i].firstSigneDocument != null && response.data[i].firstSigneDocument.trim() != '') {
                let signature: BudgetSignatures = { name: '', description: '', ci: '' };
                signature.name = response.data[i].firstSigneName;
                signature.description = response.data[i].firstSigneDescription;
                signature.ci = response.data[i].firstSigneDocument;
                listFirmasPresupuesto.push(signature);
              }

              if (response.data[i].secondSigneName != null && response.data[i].secondSigneName.trim() != '' &&
                response.data[i].secondSigneDescription != null && response.data[i].secondSigneDescription.trim() != '' &&
                response.data[i].secondSigneDocument != null && response.data[i].secondSigneDocument.trim() != '') {
                let signature: BudgetSignatures = { name: '', description: '', ci: '' };
                signature.name = response.data[i].secondSigneName;
                signature.description = response.data[i].secondSigneDescription;
                signature.ci = response.data[i].secondSigneDocument;
                listFirmasPresupuesto.push(signature);
              }

              if (response.data[i].thirdSigneName != null && response.data[i].thirdSigneName.trim() != '' &&
                response.data[i].thirdSigneDescription != null && response.data[i].thirdSigneDescription.trim() != '' &&
                response.data[i].thirdSigneDocument != null && response.data[i].thirdSigneDocument.trim() != '') {
                let signature: BudgetSignatures = { name: '', description: '', ci: '' };
                signature.name = response.data[i].thirdSigneName;
                signature.description = response.data[i].thirdSigneDescription;
                signature.ci = response.data[i].thirdSigneDocument;
                listFirmasPresupuesto.push(signature);
              }

              if (response.data[i].fourSigneName != null && response.data[i].fourSigneName.trim() != '' &&
                response.data[i].fourSigneDescription != null && response.data[i].fourSigneDescription.trim() != '' &&
                response.data[i].fourSigneDocument != null && response.data[i].fourSigneDocument.trim() != '') {
                let signature: BudgetSignatures = { name: '', description: '', ci: '' };
                signature.name = response.data[i].fourSigneName;
                signature.description = response.data[i].fourSigneDescription;
                signature.ci = response.data[i].fourSigneDocument;
                listFirmasPresupuesto.push(signature);
              }

              let presupuesto: Presupuesto = {
                creationDate: new Date(response.data[i].dateBudget),
                typeBudget: 'Estandar',
                companyBudget: response.data[i].budgetCompany,
                titleWork: response.data[i].budgetName,
                location: response.data[i].locationBudget,
                contractor: response.data[i].contractor,
                lineItemNumber: response.data[i].budgetLineItemQuantity,
                grandTotal: (totalPresupuesto + totalIvaPresupuesto + totalOtrosImpPresupuesto),
                idBudget: response.data[i].idBudget,
                iva: response.data[i].iva,
                applyIva: response.data[i].applyIva,
                otherTax: (response.data[i].otherTax != null ? response.data[i].otherTax : 0),
                signatures: listFirmasPresupuesto
              }
              this.listPresupuestos.push(presupuesto);
            }

            this.dataSourceFilters.data = this.listPresupuestos;
            this.apiCallService.hideSpinner();

          } else {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GET_ALLBUDGET_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
        });
  }

  deleteBudget(id: number) {
    const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_DELETE_BUDGET, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialog.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        this.route = '/deleteBudgetForId';
        this.method = 'POST';
        let data = {
          idBudget: id
        };

        this.apiCallService.call$(data, this.route, this.method, true, '', true)
          .pipe(takeUntil(this.destroy$)).subscribe(
            response => {
              if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.apiCallService.hideSpinner();
                const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_BUDGET_DELETED_SUCCESS, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
                dialog.afterClosed().subscribe(() => {
                  this.getAllBudget();
                });
              } else {
                this.apiCallService.hideSpinner();
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_DELETE_BUDGET_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
              }
            })
      } else {
        dialog.close(false);
      }
    });
  }

  navigateDetallePresupuesto(pBudget: any) {
    this.route = '/getAllBudgetLineItemByBudget';
        this.method = 'POST';
        let data = {
          idBudget: pBudget.idBudget
        };

        this.apiCallService.call$(data, this.route, this.method, true, '', true)
          .pipe(takeUntil(this.destroy$)).subscribe(response => {
            if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {

              response.data = response.data.reverse();
              for (let i = 0; i < response.data.length; i++) {
                let partida: BudgetItem = {
                  position: (i + 1),
                  chapterReference: (response.data[i].referenceChapter != null ? response.data[i].referenceChapter : ''),
                  reference: response.data[i].referenceBudgetLineItem,
                  code: response.data[i].codeBudgetLineItem,
                  description: response.data[i].descriptionBudgetLineItem,
                  unit: response.data[i].unitName,
                  quantity: response.data[i].lineItemQuantity,
                  unitPrice: response.data[i].calculatedUnitPrice,
                  assumedPrice: response.data[i].assumedPrice,
                  total: (response.data[i].calculatedUnitPrice * response.data[i].lineItemQuantity),
                  performance: response.data[i].performance,
                  idLineItem: response.data[i].idLineItem,
                  lineItemGrouping: response.data[i].groupingDescription,
                  idBudgetLineItem: response.data[i].idBudgetLineItem,
                  idChapterReference: (response.data[i].idChapter != null ? response.data[i].idChapter : null),
                  descriptionChapter: (response.data[i].descriptionChapter != null ? response.data[i].descriptionChapter : ''),
                  benefit: response.data[i].benefit,
                  administrativeExpense: response.data[i].administrativeExpense,
                  unexpectedUtility: response.data[i].unexpectedUtility,
                  financing: response.data[i].financing,
                  iva: response.data[i].iva,
                  otherTax: response.data[i].otherTax,
                  idLineItemUser: response.data[i].idLineItemUser
                }
                this.cachePartidasService.save(partida.idLineItem.toString(), partida);
              }

              let applyIva: number = pBudget.applyIva;
              let tipoIva: string = '';
              if (applyIva == 1) { tipoIva = Constanst.APLICAR_IVA_PRESUPUESTO };
              if (applyIva == 2) { tipoIva = Constanst.APLICAR_IVA_APU };
              if (applyIva == 3) { tipoIva = Constanst.APLICAR_IVA_NINGUNO };

              let detallePresupuesto: BudgetDetails = {
                budgetId: pBudget.idBudget,
                budgetName: pBudget.titleWork.toUpperCase(),
                contractor: pBudget.contractor,
                applyIva: tipoIva,
                companyBudget: pBudget.companyBudget,
                location: pBudget.location,
                signatures: pBudget.signatures
              };

              this.cachePartidasService.saveOnBudget(Constanst.CACHE_NAME_BUDGET_IVA, pBudget.iva);
              this.cachePartidasService.saveOnBudget(Constanst.CACHE_NAME_BUDGET_OTHERTAX, pBudget.otherTax);
              localStorage.setItem(Constanst.STORAGE_DATA_BUDGETSELECT, JSON.stringify(pBudget));
              this.helperClassService.setData(detallePresupuesto);
              this.apiCallService.hideSpinner();
              this.router.navigate(['/infoPresupuesto']);
        } else {
          this.apiCallService.hideSpinner();
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
            }
    });
  }

  navigateHomeLineItem() {
    localStorage.setItem(Constanst.STORAGE_DATA_SCREENTYPE, Constanst.SCREEN_TYPE_BD);
    this.router.navigate(['/' + 'home']);
  }
}
